import { Slider, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'

export const MySlider = (props) => {
  const { name, value, min, max, configs, setConfigs, target } = props
  const handleChange = (event, newValue) => {
    const newConfigs = JSON.parse(JSON.stringify(configs))
    newConfigs[target] = newValue
    setConfigs(newConfigs)
  }

  return (
    <Box sx={{ width: "300px" }}>
      <Typography>{name}</Typography>
      <Slider
        value={value}
        valueLabelDisplay="auto"
        min={min} max={max}
        onChange={handleChange}
      />
    </Box>

  )
}
